import type { CSSProperties, ImgHTMLAttributes } from 'react'
import type { ImageProps } from 'antd'
import { Popover, Image as AImage } from 'antd'
import { EyeOutlined } from '@ant-design/icons'
import Image from './Image'
import { omit } from 'lodash'

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  defaultSrc?: string,
  useAntd?: boolean,
  antdProps?: ImageProps,
  popEnable?: boolean,
  popStyle?: CSSProperties
}

const EasyImg = (props: Props) => {
  const {
    defaultSrc = require('src/assets/common/easyImg.png'),
    useAntd,
    antdProps,
    popEnable,
    popStyle,
    className,
    style
  } = props

  if (useAntd) {
    const preview = typeof antdProps?.preview === 'boolean' ? antdProps.preview : { mask: <EyeOutlined />, ...antdProps?.preview }
    return (
      <AImage
        {...antdProps}
        fallback={antdProps?.fallback || defaultSrc}
        preview={preview}
      />
    )
  }

  const imgProps = omit(props, ['useAntd', 'antdProps', 'popEnable', 'popStyle'])
  return (
    <Popover
      trigger={['click']}
      content={
        popEnable
          ? <Image {...imgProps} style={{ ...style, ...popStyle }} />
          : undefined
      }
    >
      <Image {...imgProps} className={`${className} ${popEnable ? 'cursor-pointer' : ''}`} />
    </Popover>
  )
}

export default EasyImg